<template>
  <material-chart-card
    color="red"
    type="Bar"
    elevation="0"
    :data="chartData"
    :options="options"
    :responsive-options="responsiveOptions"
  >
    <v-layout>
      <v-flex>
        <div class="headline font-weight-light mb-1">Wartość usług</div>

        <div class="category d-inline-flex font-weight-light mr-2">
          Wartość dzienna usług udostępnionych za pomocą kart
        </div>
      </v-flex>
    </v-layout>

    <template slot="actions">
      <v-layout>
        <v-flex> <v-icon class="mr-2" small>mdi-calendar</v-icon>Ostatni tydzień </v-flex>
      </v-layout>
    </template>
  </material-chart-card>
</template>

<script>
import MaterialChartCard from '@/components/material/ChartCard';
import { chartMixin } from '@/mixins/chart';

// @vuese
// Wykres z wartością usług
// @group Chart
export default {
  components: { MaterialChartCard },
  mixins: [chartMixin],
  props: {
    // opcje wykresu
    chartOptions: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      options: {
        axisY: {
          onlyInteger: true
        },
        axisX: {
          showGrid: false
        },
        low: 0,
        chartPadding: {
          top: 27,
          right: 15,
          bottom: 0,
          left: 0
        },
        ...this.chartOptions
      },
      responsiveOptions: [
        [
          'screen and (max-width: 640px)',
          {
            seriesBarDistance: 5
          }
        ]
      ],
      chartData: this.generateChartData(this.$store.state.stats.benefitsValue)
    };
  },
  watch: {
    '$store.state.stats.benefitsValue'() {
      this.chartData = this.generateChartData(this.$store.state.stats.benefitsValue);
    }
  }
};
</script>
